<template :pageData="pageData">
	<div class="page-wrapper">
		<div class="header">
			<div class="title">Kext</div>
			<a href="https://github.com/xzhih/hackintosh-list" class="submit">Submit</a>
		</div>
		<div class="kext-wrapper">
			<table class="kext-table shadow">
				<template v-for="(sorts, key) in pageData.Kext">
					<div class="kext-sort" :key="key">{{ key }}</div>
					<tr v-for="item in sorts" :key="item.Name">
						<td>{{ item.Name }}</td>
						<td class="kext-des">{{ item.Description }}</td>
						<td class="get-kext">
							<a :href="item.Link" target="_blank" title="get kext">
								<img src="../static/icons/download.svg" alt="download">
							</a>
						</td>
					</tr>
				</template>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Kext',
		props: ['pageData']
	}
</script>

<style src="../assets/style.css"></style>
